"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainId = exports.Middleware = exports.Bridge = void 0;
var Bridge;
(function (Bridge) {
    Bridge["Hop"] = "hop";
    Bridge["AnySwap"] = "anyswap";
    Bridge["AnySwapRouterV4"] = "anyswap-router-v4";
    Bridge["AnySwapRouterV6"] = "anyswap-router-v6";
    Bridge["PolygonBridge"] = "polygon-bridge";
    Bridge["ArbitrumBridge"] = "arbitrum-bridge";
    Bridge["Hyphen"] = "hyphen";
    Bridge["Across"] = "across";
    Bridge["OptimismBridge"] = "optimism-bridge";
    Bridge["Celer"] = "celer";
    Bridge["refuel"] = "refuel-bridge";
    Bridge["Stargate"] = "stargate";
    Bridge["Connext"] = "connext";
    Bridge["CCTP"] = "cctp";
})(Bridge = exports.Bridge || (exports.Bridge = {}));
var Middleware;
(function (Middleware) {
    Middleware["OneInch"] = "oneinch";
    Middleware["ZeroX"] = "zerox";
    Middleware["Rainbow"] = "rainbow";
    Middleware["refuelOneInch"] = "refuel-oneinch";
    Middleware["refuelRainbow"] = "refuel-rainbow";
    Middleware["refuelZeroX"] = "refuel-zerox";
    Middleware["refuel"] = "refuel";
})(Middleware = exports.Middleware || (exports.Middleware = {}));
var ChainId;
(function (ChainId) {
    ChainId[ChainId["GOERLI_CHAIN_ID"] = 5] = "GOERLI_CHAIN_ID";
    ChainId[ChainId["KOVAN_CHAIN_ID"] = 42] = "KOVAN_CHAIN_ID";
    ChainId[ChainId["POLYGON_CHAIN_ID"] = 137] = "POLYGON_CHAIN_ID";
    ChainId[ChainId["MUMBAI_CHAIN_ID"] = 80001] = "MUMBAI_CHAIN_ID";
    ChainId[ChainId["MAINNET_CHAIN_ID"] = 1] = "MAINNET_CHAIN_ID";
    ChainId[ChainId["RINKEBY_CHAIN_ID"] = 4] = "RINKEBY_CHAIN_ID";
    ChainId[ChainId["ROPSTEN_CHAIN_ID"] = 3] = "ROPSTEN_CHAIN_ID";
    ChainId[ChainId["ARBITRUM_TESTNET_CHAIN_ID"] = 421611] = "ARBITRUM_TESTNET_CHAIN_ID";
    ChainId[ChainId["XDAI_CHAIN_ID"] = 100] = "XDAI_CHAIN_ID";
    ChainId[ChainId["SOKOL_CHAIN_ID"] = 77] = "SOKOL_CHAIN_ID";
    ChainId[ChainId["ARBITRUM_CHAIN_ID"] = 42161] = "ARBITRUM_CHAIN_ID";
    ChainId[ChainId["FANTOM_CHAIN_ID"] = 250] = "FANTOM_CHAIN_ID";
    ChainId[ChainId["OPTIMISM_CHAIN_ID"] = 10] = "OPTIMISM_CHAIN_ID";
    ChainId[ChainId["AVAX_CHAIN_ID"] = 43114] = "AVAX_CHAIN_ID";
    ChainId[ChainId["BSC_CHAIN_ID"] = 56] = "BSC_CHAIN_ID";
    ChainId[ChainId["AURORA_CHAIN_ID"] = 1313161554] = "AURORA_CHAIN_ID";
    ChainId[ChainId["POLYGON_ZKEVM_CHAIN_ID"] = 1101] = "POLYGON_ZKEVM_CHAIN_ID";
    ChainId[ChainId["ZKSYNC_ERA_CHAIN_ID"] = 324] = "ZKSYNC_ERA_CHAIN_ID";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
